module.exports = __webpack_public_path__ + "img/lady-beetle.724a3006.png";